/**
 * ! requires a gatsby-image compatible fluid image property
 */
export function edgeToEdgeImageSizes(fluidImage) {
  const sizesMediaQuery = `
  (max-width: 2879px) 100vw,
  (min-width: 2880px), 2880px,
   `;
  const image = {
    ...fluidImage,
    fluid: { ...fluidImage?.fluid, sizes: sizesMediaQuery },
  };
  return image;
}

// setting different sizes for different pixel ratios here since safari tend to download the largest
// possible image from the srcSet on dynamic sizes (or rather doesn't cancel the download initiated before the js is loaded)
export function gridImageSizes(fluidImage) {
  const sizesMediaQuery = `
    (-webkit-min-device-pixel-ratio: 2) 900px, 1400px,
  `;
  const image = {
    ...fluidImage,
    fluid: { ...fluidImage?.fluid, sizes: sizesMediaQuery },
  };
  return image;
}
